import React, { Component } from 'react'
import {
    Row,
    Col,
    Card,
    Form,
    Button,
    Input,
    Alert,
    Modal,
    message
} from 'antd'
import { CopyOutlined, UnlockOutlined } from '@ant-design/icons'
import InputMask from 'react-input-mask'
import styled from 'styled-components'
import { activate } from '../../services/apiServices'
import { copyToClipboard } from '../../services/appServices'
import LoadingModal from '../../commons/Modal/Loading'

const Container = styled(Card)`
    .ant-form-item-control {
        width: 100%;
    }
    .code-input {
        text-transform: uppercase;
        text-align: center;
    }
    .domain-wrapper {
        margin-top: 15px;
        margin-bottom: 15px;
        .ant-alert {
            text-align: center;
            font-size: 20px !important;
        }
    }
    .button-wrapper {
        margin-top: 15px;
        text-align: center;
    }
`

class Activate extends Component {
    state = {
        isLoading: false,
        code: ''
    }

    async activate(code) {
        let { T } = this.props
        this.setState({ isLoading: true })
        try {
            let { status } = await activate({ body: { info: code } })
            this.setState({ isLoading: false })
            if (status === 0) {
                Modal.success({
                    centered: true,
                    title: T('CODE_VALID'),
                    content: T('CODE_VALID_DESC'),
                    okText: T('OK'),
                    onOk() {
                        window.location.hash = ''
                        window.location.reload()
                    }
                })
            } else {
                Modal.error({
                    centered: true,
                    title: T('CODE_NOT_VALID'),
                    content: T('CODE_NOT_VALID_DESC'),
                    okText: T('OK')
                })
            }
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(T('SOMETHING_WRONG'))
        }
    }

    onActivate() {
        if (this.state.code) {
            let code = this.state.code.split('-').join('')
            code = code.toUpperCase().trim()
            this.activate(code)
        } else {
            message.warning(this.props.T('FORM_ERR_ACTIVATION_CODE_REQUIRE'))
        }
    }

    onCopyDomain() {
        message.success('copied!')
    }

    onChangeCode(code) {
        this.setState({
            code
        })
    }

    onCopyToClipboard(code) {
        copyToClipboard(code)
        message.success(this.props.T('COPIED'))
    }

    render() {
        let { T } = this.props
        return (
            <Container
                title={
                    <span className="text-xl">
                        <UnlockOutlined /> {T('ACTIVATION_CODE')}
                    </span>
                }>
                <Row type="flex" justify="center">
                    <Col xs={24} md={18} lg={12}>
                        <div className="domain-wrapper">
                            <Form.Item
                                label={T('REQUEST_CODE')}
                                tooltip={T('REQUEST_CODE_DESC')}>
                                <Alert
                                    classNam="domain-wrapper"
                                    message={
                                        <div>
                                            <div>
                                                {window.config.requestCode}
                                            </div>
                                            <Button
                                                size="small"
                                                icon={<CopyOutlined />}
                                                onClick={() =>
                                                    this.onCopyToClipboard(
                                                        window.config
                                                            .requestCode
                                                    )
                                                }>
                                                {T('COPY')}
                                            </Button>
                                        </div>
                                    }
                                    type="info"
                                />
                            </Form.Item>
                        </div>
                        <Form.Item label={T('ACTIVATION_CODE')}>
                            <InputMask
                                mask="****-****-****-****"
                                maskChar=" "
                                className="ant-input ant-input-lg code-input"
                                value={this.state.code}
                                onChange={e =>
                                    this.onChangeCode(e.target.value)
                                }
                                render={(ref, props) => (
                                    <Input
                                        name="activation_code"
                                        required
                                        ref={ref}
                                        {...props}
                                    />
                                )}
                            />
                        </Form.Item>
                        <div className="button-wrapper">
                            <Button
                                type="primary"
                                shape="round"
                                icon={<UnlockOutlined />}
                                size="large"
                                onClick={() => this.onActivate()}>
                                Activate
                            </Button>
                        </div>
                    </Col>
                </Row>

                <LoadingModal isOpen={this.state.isLoading} />
            </Container>
        )
    }
}

export default Activate
